import { ProductGroups, Routes } from 'enums';
import { NavigationStates } from 'stores/app-bar-navigation-store';

export type CoPilotNavigationTab =
  | NavigationStates.PROJECTS
  | NavigationStates.TOOL
  | NavigationStates.LINKEDIN_ACCOUNT_MANAGEMENT
  | NavigationStates.BLACKLIST
  | NavigationStates.STATISTICS
  | NavigationStates.INBOX
  | NavigationStates.TASK_MANAGER;

export type CoPilotTabRoutes = Record<CoPilotNavigationTab, Routes>;

export const RECRUITING_CO_PILOT_TAB_ROUTES: CoPilotTabRoutes = {
  [NavigationStates.PROJECTS]: Routes.RECRUITING_BOOSTER_CO_PILOT_PROJECTS,
  [NavigationStates.TOOL]: Routes.RECRUITING_BOOSTER_CO_PILOT_CAMPAIGN,
  [NavigationStates.LINKEDIN_ACCOUNT_MANAGEMENT]: Routes.RECRUITING_BOOSTER_CO_PILOT_ACCOUNTS,
  [NavigationStates.BLACKLIST]: Routes.RECRUITING_BOOSTER_CO_PILOT_BLACKLIST,
  [NavigationStates.STATISTICS]: Routes.RECRUITING_BOOSTER_CO_PILOT_STATISTICS,
  [NavigationStates.INBOX]: Routes.RECRUITING_BOOSTER_CO_PILOT_INBOX,
  [NavigationStates.TASK_MANAGER]: Routes.RECRUITING_BOOSTER_CO_PILOT_TASKS,
};

export const LEAD_CO_PILOT_TAB_ROUTES: CoPilotTabRoutes = {
  [NavigationStates.PROJECTS]: Routes.LEAD_BOOSTER_CO_PILOT_PROJECTS,
  [NavigationStates.TOOL]: Routes.LEAD_BOOSTER_CO_PILOT_CAMPAIGN,
  [NavigationStates.LINKEDIN_ACCOUNT_MANAGEMENT]: Routes.LEAD_BOOSTER_CO_PILOT_ACCOUNTS,
  [NavigationStates.BLACKLIST]: Routes.LEAD_BOOSTER_CO_PILOT_BLACKLIST,
  [NavigationStates.STATISTICS]: Routes.LEAD_BOOSTER_CO_PILOT_STATISTICS,
  [NavigationStates.INBOX]: Routes.LEAD_BOOSTER_CO_PILOT_INBOX,
  [NavigationStates.TASK_MANAGER]: Routes.LEAD_BOOSTER_CO_PILOT_TASKS,
};

export const getCoPilotTabRoutes = (productGroup: ProductGroups): CoPilotTabRoutes => {
  return productGroup === ProductGroups.HR_BOOSTER ? RECRUITING_CO_PILOT_TAB_ROUTES : LEAD_CO_PILOT_TAB_ROUTES;
};

export const getCoPilotRouteForPathAndTab = (pathname: string, tab: CoPilotNavigationTab): Routes | undefined => {
  if (isRecruitingCoPilotPath(pathname)) {
    return RECRUITING_CO_PILOT_TAB_ROUTES[tab];
  }

  if (isLeadCoPilotPath(pathname)) {
    return LEAD_CO_PILOT_TAB_ROUTES[tab];
  }

  return undefined;
};

export const isRecruitingCoPilotPath = (pathname: string): boolean => pathname.startsWith(Routes.RECRUITING_BOOSTER_CO_PILOT);

export const isLeadCoPilotPath = (pathname: string): boolean => pathname.startsWith(Routes.LEAD_BOOSTER_CO_PILOT);

export const isCoPilotPath = (pathname: string): boolean => isRecruitingCoPilotPath(pathname) || isLeadCoPilotPath(pathname);
